/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Short_Item_1Inputs */



/**
* | output |
* | --- |
* | "Detection accuracy depends on your configuration." |
*
* @param {Guardrails_Short_Item_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_short_item_1 = /** @type {((inputs?: Guardrails_Short_Item_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Short_Item_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Erkennungsgenauigkeit hängt von Ihrer Konfiguration ab")
	return /** @type {LocalizedString} */ ("Detection accuracy depends on your configuration.")
});